import LocationQrCodeModal from './LocationQrCodeModal';

export default LocationQrCodeModal;
